import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Textinput, Flex } from '../../../ui';

const EditWebinarModal = ({ open, onClose, onSubmit, currentName }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(currentName || '');

  const handleAccept = async () => {
    await onSubmit({ name });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('classroom.editWebinar', 'Edit Webinar Name')}
      width='440px'
      showActions
      onAccept={handleAccept}
      acceptLabel={t('globals.save', 'Save')}
      acceptIsDisabled={!name.trim() || name === currentName}
    >
      <Flex direction='column' gap='16'>
        <Textinput
          label={t('classroom.webinarName', 'Webinar Name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='e.g. Mathematics — Live Lesson: Week 7'
        />
      </Flex>
    </Modal>
  );
};

export default EditWebinarModal;
